import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme) => createStyles({
    root: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
        margin: 4,
    },
    base: {
        gridColumnStart: 1,
        gridRowStart: 1,
    },
    captionDiv: {
        gridColumnStart: 1,
        gridRowStart: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.primary,
    },
    labelDiv: {
        textAlign: "center",
    },
}));
//i think ideally this guy goes away
export const ColoredProgressDial = ({ variant = "lg", macroLabel = "", insetLabel, label, color }) => {
    const classes = useStyles();
    const circularProgressProps = {
        lg: {
            thickness: 5,
            size: 90,
        },
        md: {
            thickness: 4,
            size: 60,
        },
        sm: {
            thickness: 4,
            size: 45,
        },
    };
    return (_jsxs("div", { children: [_jsxs("div", { className: classes.root, children: [_jsx(CircularProgress, { "aria-label": macroLabel, "aria-valuetext": insetLabel, className: classes.base, variant: "determinate", classes: { colorPrimary: color }, value: 100, ...circularProgressProps[variant] }), _jsx("div", { className: classes.captionDiv, style: { width: circularProgressProps[variant].size }, children: _jsx(Typography, { variant: "subtitle1", "aria-hidden": "true", children: insetLabel }) })] }), _jsx("div", { className: classes.labelDiv, "aria-hidden": "true", children: label })] }));
};
//# sourceMappingURL=ColoredProgressDial.js.map